import { InvalidEngagementStateStrategy } from './invalid-engaement-state-strategy.model';

export class UserNoLongerSignatoryStrategyModel extends InvalidEngagementStateStrategy {

  constructor(engagementId: number, hasAdditionalTasks: boolean) {
    super(engagementId, hasAdditionalTasks);
  }

  getTitle() { return 'Looks like your signature is no longer needed on this document.'; }
  getImagePath() { return 'sig-no-longer-needed.png'; }
}
